import { render, staticRenderFns } from "./HourClassIndex.vue?vue&type=template&id=1ea5e990"
import script from "./HourClassIndex.vue?vue&type=script&lang=js"
export * from "./HourClassIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports